export default "<app-wo-stopped-list [orderStatus]=\"'CA'\" [allowRecover]=\"false\"></app-wo-stopped-list>\n"